import React from "react";
import { ArrowBackCircle } from "react-ionicons";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import constantURI from "../URI";
import stylesASAP from "./stylesASAP";
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { set, get } from "idb-keyval";
import ReactToPrint from "react-to-print";
import { forwardRef } from "react";

import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer } from "recharts";
import formatAmount from "../Functions/FormatCurrency";

export default class StatmentDetails extends React.Component {
  constructor() {
    super();
    this.state = {
      Data: [],
      IdClientDetails: 0,
      dataofzero: [],
    };
  }

  async componentDidMount() {
    const IdClientDetails = JSON.parse(localStorage.getItem("IdClientDetails"));
    const token = JSON.parse(localStorage.getItem("Token"));
    const userId = JSON.parse(localStorage.getItem("UserId"));

    await this.setState({
      IdClientDetails: IdClientDetails,
    });

    const GetReportByType =
      constantURI() +
      "GetTransDetails?transId=" +
      IdClientDetails +
      "&token=" +
      token +
      "&user=" +
      userId;

    await _post(GetReportByType).then((response) => {
      return response.json().then(async (data) => {
        if (data !== undefined) {
          await this.setState({ Data: data, dataofzero: data[0] });
        }
      });
    });
  }

  render() {
    console.log(this.state.Data[0]);
    console.log(this.state.dataofzero);
    return (
      <div className="container-fluid v-100" style={stylesASAP.reportcolor}>
        <div className="row pt-3" style={stylesASAP.above}>
          <div className="col">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.goBack()}
              color={"#6C757D"}
              height="50px"
              width="50px"
            />
          </div>
        </div>

        <div className="table-responsive mt-4">
          <table className="table table-bordered table-striped table-hover shadow-sm">
            <thead className="thead-dark">
              <tr>
                <th>ItemName</th>
                <th>Qty</th>
                <th>Currency</th>
                <th>Free</th>
                <th>Price</th>
                <th>Disc</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {this.state.Data !== undefined && this.state.Data !== null
                ? this.state.Data.map((user, index) => (
                    <tr>
                      <td>{user.ItemName}</td>
                      <td>{user.Quantity}</td>
                      <td>{user.CurrencyCode}</td>
                      <td>{user.FreeQuantity}</td>
                      <td>{formatAmount(user.Price)}</td>
                      <td>{user.LineDiscPerc}</td>
                      <td>{formatAmount(user.LineTotal)}</td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
        <div>
  {this.state.Data !== undefined && this.state.Data.length > 0
    ? this.state.Data.map((item, index) =>
        index === 0 ? (
          <div key={item.id} className="p-3 mb-3">
            {/* Gross */}
            <p className="clearfix mb-3 text-end">  
              <strong>Gross:</strong> {formatAmount(item.Gross)}
            </p>
            
            {/* ACTotTax */}
            <p className="clearfix mb-3 text-end">
              <strong>ACTotTax:</strong> {formatAmount(item.ACTotTax)}
            </p>
            
            {/* ACTotal */}
            <p className="clearfix mb-3 text-end">
              <strong>ACTotal:</strong> {formatAmount(item.ACTotal)}
            </p>
            
            {/* ACDiscount */}
            <p className="clearfix mb-3 text-end">
              <strong>ACDiscount:</strong> {formatAmount(item.ACDiscount)}
            </p>
            
            {/* B2TotTax */}
            <p className="clearfix mb-2 text-end">
              <strong>B2TotTax:</strong> {formatAmount(item.B2TotTax)}
            </p>
          </div>
        ) : null
      )
    : null}
</div>
        {/* <div>
          {this.state.Data !== undefined && this.state.Data.length > 0
            ? this.state.Data.map((item, index) =>
                index === 0 ? (
                  <div key={item.id} className="border p-3 mb-3">
                    <p className="clearfix">
                      Gross: <span className="float-end">{item.Gross}</span>
                    </p>
                    <p className="clearfix">
                      ACTotTax:{" "}
                      <span className="float-end">{item.ACTotTax}</span>
                    </p>
                    <p className="clearfix">
                      ACTotal: <span className="float-end">{item.ACTotal}</span>
                    </p>
                    <p className="clearfix">
                      ACDiscount:{" "}
                      <span className="float-end">{item.ACDiscount}</span>
                    </p>
                    <p className="clearfix">
                      B2TotTax:{" "}
                      <span className="float-end">{item.B2TotTax}</span>
                    </p>
                  </div>
                ) : null
              )
            : null}
        </div> */}
      </div>
    );
  }
}
